import * as React from "react"
import { SVGProps } from "react"

const Minimise = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.5}
    className="w-6 h-6"
    viewBox="0 0 24 24"
    {...props}
  >
    <title>Minimise</title>
    <path strokeLinecap="round" strokeLinejoin="round" d="M5 12h14" />
  </svg>
)

export default Minimise
